import React from 'react';
import { SvgIcon } from './utils/SvgIcon.js';
import type { SvgIconT } from './utils/react-desc-prop-types.js';

const CommentsUnread = (props: SvgIconT.Props) => (
  <SvgIcon width={24} height={24} {...props} viewBox="0 0 24 24">
    <path d="M 18 -0.0035 C 19.0531 -0.0004 19.9151 0.8139 19.9941 1.8474 L 20 1.9965 L 20 11.9965 C 19.9969 13.0496 19.1826 13.9116 18.1491 13.9906 L 18 13.9965 L 9.3333 13.9965 L 5.6049 16.7928 C 5.4331 16.9238 5.2232 16.9949 5.0072 16.9952 C 4.7402 16.9961 4.4838 16.8906 4.2948 16.702 C 4.1373 16.5449 4.0374 16.3408 4.0086 16.1227 L 4 15.9904 L 4 13.9965 L 2 13.9965 C 0.9469 13.9934 0.0849 13.1791 0.0059 12.1456 L 0 11.9965 L 0 1.9965 C 0.0031 0.9434 0.8174 0.0814 1.8509 0.0024 L 2 -0.0035 L 18 -0.0035 Z"></path>
  </SvgIcon>
);

export default CommentsUnread;
